import { Base } from "./cashback.base";
import { Information } from "./components/information/information";
import { Price } from "./components/price/price";
import { ProductLabel } from "./components/productLabel/productLabel";

export const Cashback = Object.assign(Base, {
    ProductLabel: ProductLabel,
    PriceAfterCashbackIsApplied: Price,
    Information: Information
});
